import app from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"

const config = {
  // apiKey: process.env.REACT_APP_API_KEY,
  // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // databaseURL: process.env.REACT_APP_DATABASE_URL,
  // projectId: process.env.REACT_APP_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_ID,
  apiKey: 'AIzaSyCInK4dxZx6OTOijt675AVrzqzlPJ45Uxw',
  authDomian: 'covid-partner.firebaseapp.com',
  databaseURL: 'https://covid-partner.firebaseio.com',
  projectId: 'covid-partner',
  storageBucket: 'covid-partner.appspot.com',
  messagingSenderId: '987100871355',
  appId: '1:987100871355:web:e8947cc6e970517a6ac79e',
}

class Firebase{
  constructor(){
    app.initializeApp(config)
    this.auth = app.auth()
    this.db = app.firestore()
  }

  doCreateUserWithEmailAndPassword = (location, name, email, password) => {
    return this.auth.createUserWithEmailAndPassword(email, password).catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      if (errorCode === 'auth/weak-password') {
        alert('The password is too weak.');
      } else {
        alert(errorMessage);
      }
    });
  }

  doSignInWithEmailAndPassword = (email, password) => {
    return this.auth.signInWithEmailAndPassword(email, password).catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      if (errorCode === 'auth/wrong-password') {
        alert('Wrong password.');
      } else {
        alert(errorMessage);
      }
    });
  }

  doSignOut = () => this.auth.signOut()

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);
}

const firebase = new Firebase();

export default firebase;